import * as React from "react";
import { Form, Field, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import {
  Label
} from "@progress/kendo-react-labels";
import {
  ListView,
  ListViewItemProps,
} from "@progress/kendo-react-listview";
import {
  Card,
  CardBody,
  Stepper,
  StepperChangeEvent,
} from "@progress/kendo-react-layout";
import { CheckboxChangeEvent, Switch } from "@progress/kendo-react-inputs";
import { useEffect } from "react";
import { ListAbschnitte, ListFragen, ListSysteme, Umfrage } from "../models";
import { FormCheckbox, FormCheckboxList, FormComboBox, FormDatePicker, FormInput, FormNumericTextBox, FormRadioGroup, FormSwitch, FormTextArea } from "./FormComponents";
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { config } from '../config';
import { filterBy, FilterDescriptor } from "@progress/kendo-data-query";

export function requiredValidator (lang,value) {
  
  switch(lang){
    case "de":
      return !value ? "Pflichtfeld" : ""
    case "en":
      return !value ? "Required" : "";
    case "es":
      return !value ? "Requerido" : "";
  }

  return !value ? "Required" : "";
}


const Form_PageComponent = (props) => {
  const u: Umfrage = { header: "", description: "", isChecked: false, title: "", listAbschnitte: [], listSysteme: [], cacheItems: [] };
  const abschnitt: ListAbschnitte = {
    id: "",
    titel: "",
    subTitel: "",
    label: "",
    listFragen: [],
    reihenfolge: -1,
    gfaSystemId: "",
    isVisible: false,
    dependingOn: "",
    dependingOnValue: ""
  };

  const [isFinalPage, setIsFinalPage] = React.useState(false);
  const [btnFormularAbsenden, setBtnFormularAbsenden] = React.useState("Formular absenden");
  const [btnWeiter, setBtnWeiter] = React.useState("Next");
  const [btnZuerueck, setBtnZuerueck] = React.useState("Back");
  const [textFinish, setTextFinish] = React.useState("");
  const [textSystemHeader, setTextSystemHeader] = React.useState(props.titleSystem);
  const [textSystemBody, setTextSystemBody] = React.useState(props.subTitleSystem);
  const listSysteme: ListSysteme[] = [];
  const listAbschnitte: ListAbschnitte[] = [];
  const [isDebug, setIsDebug] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<number>(0);
  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState(true);
  const [ButtonIsLoading, setButtonIsLoading] = React.useState(false);
  const [spinnerAbschnitte, setSpinnerAbschnitte] = React.useState(false);
  const [umfrage, setUmfrage] = React.useState<Umfrage>(u);
  const [umfrageLoaded, setUmfrageLoaded] = React.useState<boolean>(false);
  const [abschnitte, setAbschnitte] = React.useState<ListAbschnitte[]>([]);
  const [systeme, setSysteme] = React.useState<ListSysteme[]>([]);
  const [currentAbschnitt, setCurrentAbschnitt] =
    React.useState<ListAbschnitte>(abschnitt);
  const [checked, setChecked] = React.useState(false);
  const formRef = React.useRef(null);

  const [filter, setFilter] = React.useState<FilterDescriptor>();
  const [data, setData] = React.useState<any[]>([]);
  const [fullData, setFulldata] = React.useState<any[]>([]);
  const timeout = React.useRef<any>();
  const filterData = (filter: FilterDescriptor) => {
    const localData = fullData.slice();
    return filterBy(localData, filter);
  };

  const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setData(filterData(event.filter));
    }, 500);
  };

  const columns = [
    { field: "schemaName", header: "schemaName", width: "300px" }
  ];


  useEffect(() => {

    // Abschluss des Fragebogens
    if (value == 100) {
      var sessionid = localStorage.getItem("umfrage_sessionid") == null ? "" : localStorage.getItem("umfrage_sessionid") as string;

      var language = props.match.params.language;

      fetch(`${config.Umfrage_URL}umfrage`,
        {
          headers: {
            "SESSION_ID": sessionid,
            "IS_FINISHED": "true",
            "IS_FORM_REQUEST": "true",
            "LANG": language
          }
        });

      localStorage.removeItem("umfrage_sessionid");
    }
  }, [value]);

  useEffect(() => {

    var sessionid = localStorage.getItem("umfrage_sessionid") == null ? "" : localStorage.getItem("umfrage_sessionid") as string;

    var language = props.match.params.language;

    switch (language) {
      case "de":
        // setTextSystemHeader("Anfrageformular");
        // setTextSystemBody("Wir möchten nach dem/den folgenden System(en) zertifiziert werden");
        setBtnFormularAbsenden("Formular absenden");
        setBtnWeiter("Weiter");
        setBtnZuerueck("Zurück");
        setTextFinish("Vielen Dank für Ihr Interesse an einer Zertifizierung durch die GFA Certification GmbH. Wir haben Ihren Antrag erhalten und werden uns in Kürze mit Ihnen in Verbindung setzen. Wenn Sie noch Fragen haben, stehen wir Ihnen jederzeit gerne zur Verfügung.")
        break;
      case "en":
        // setTextSystemHeader("Application questionnaire");
        // setTextSystemBody("We would like to be certified according to the following systems.");
        setBtnFormularAbsenden("Send Request");
        setBtnWeiter("Next");
        setBtnZuerueck("Back");
        setTextFinish("Thank you for your interest in certification by GFA Certification GmbH. We have received your application and will be in touch with you shortly.If you have any questions, we are always at your disposal.");
        break;
      case "es":
        // setTextSystemHeader("Cuestionario de aplicación");
        // setTextSystemBody("Nos gustaría estar certificados de acuerdo con los siguientes sistemas.");
        setBtnFormularAbsenden("Enviar formulario");
        setBtnWeiter("Adelante");
        setBtnZuerueck("Volver");
        setTextFinish("Gracias por su interés en la certificación de GFA Certification GmbH. Hemos recibido su solicitud y en breve nos pondremos en contacto con usted. Si tiene alguna pregunta, estamos siempre a su disposición.");
        break;
    }

    fetch(`${config.Umfrage_URL}umfrage`,
      {
        headers: {
          "SESSION_ID": sessionid,
          "IS_FORM_REQUEST": "true",
          "LANG": language
        }
      })
      .then((response) => {

        var json = response.json();
        var sessionid = response.headers.get("session_id") == null ? "" : response.headers.get("session_id") as string;

        if (localStorage.getItem("umfrage_sessionid") == null)
          localStorage.setItem("umfrage_sessionid", sessionid);
        return json;
      })
      .then(function (resp: any) {
        const umfrage: Umfrage = resp;

        setFulldata(umfrage.cacheItems);

        setUmfrage(umfrage);

        setSysteme(umfrage.listSysteme);

        setAbschnitte(umfrage.listAbschnitte);

        setUmfrageLoaded(true);
        setLoading(false);
      });

  }, [umfrageLoaded]);


  useEffect(() => {
    loadAbschnitte();
  }, [umfrage.listAbschnitte]);

  const loadAbschnitte = () => {

    var listFragen: ListFragen[] = [];

    var listAbschnitteTemp: ListAbschnitte[] = [];

    // default abschnitt
    var abschnittAuswahl: ListAbschnitte = {
      label: "System",
      titel: "",
      subTitel: "",
      reihenfolge: -1,
      id: "",
      listFragen: [],
      gfaSystemId: "",
      isVisible: false,
      dependingOn: "",
      dependingOnValue: ""
    };

    listAbschnitteTemp.push(abschnittAuswahl);

    umfrage.listAbschnitte.forEach((ab: ListAbschnitte) => {
      ab.listFragen.forEach((fr: ListFragen) => {
        listFragen.push(fr);
      })
    });

    if (umfrage.listAbschnitte.length > 1)

      umfrage.listAbschnitte.forEach((abschnitt: ListAbschnitte) => {
        if (abschnitt.gfaSystemId == "00000000-0000-0000-0000-000000000000") {
          listAbschnitteTemp.push(abschnitt);
        }

        if (abschnitt.dependingOnValue == "") {
          for (let index = 0; index < umfrage.listSysteme.length; index++) {
            var system = umfrage.listSysteme[index];

            if (abschnitt.gfaSystemId == system.id) {
              abschnitt.isVisible = system.isChecked;

              if (abschnitt.isVisible)
                listAbschnitteTemp.push(abschnitt);
            }
          }
        }
        else {
          var frage = listFragen.find(_ => _.id == abschnitt.dependingOn);

          if (frage != null) {

            var elements = document.getElementsByName(frage.id);

            if (elements.length > 0) {
              var element = elements[0] as HTMLInputElement;

              if (element != null && element.value != null) {
                var elementValues = element.value.split(',');

                for (var idx in elementValues) {
                  if (elementValues[idx] == abschnitt.dependingOnValue) {
                    listAbschnitteTemp.push(abschnitt);
                  }
                }
              }
            }
          }
        }

      });

    setAbschnitte(listAbschnitteTemp);

  }

  const toggleDialog = () => {
    setShowDialog(!showDialog);
  };

  function OnChangeComboboxFrage(frage: ListFragen, ev: ComboBoxChangeEvent): void {

    fetch(`${config.Umfrage_URL}umfrage`, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ "Id": frage.id, "targetColumn": ev.value.schemaName })
    });
  }

  const goBack = () => {
    try {
      var abschnitt = abschnitte[value - 1];

      if (abschnitt != null) {
        setCurrentAbschnitt(abschnitt);
        setValue(value - 1);
      }
    } catch (e) { }
  }

  const handleSubmit = (dataItem: { [name: string]: any }, formRef: any) => {

    var abschnitt = abschnitte[value + 1];
    var newValue = value + 1;
    var isFinalPage = false;
    if (abschnitt != null) {
      setCurrentAbschnitt(abschnitt);
      setValue(newValue);
    }
    else {
      setCurrentAbschnitt({ gfaSystemId: '', id: '', isVisible: true, label: "", listFragen: [], reihenfolge: 0, subTitel: "", titel: "", dependingOn: "", dependingOnValue: "" });
      setValue(100);
    }

    if ((abschnitte.length - 1) == newValue) {
      isFinalPage = true;
      setIsFinalPage(isFinalPage);
    }

    var newValues = dataItem;

    formRef.current.fields.forEach(id => {
      var element = document.getElementsByName(id).length == 0 ? null : document.getElementsByName(id)[0] as HTMLInputElement;

      if (element?.getAttribute("customAttrType") != null) {
        var type = element.getAttribute("customAttrType");

        if (type == "checkbox") {
          newValues[id] = element.value;
        }
      }
    });

    Save(newValues);
  };

  const Save = (dataItem) => {
    setButtonIsLoading(true);
    var session_id = localStorage.getItem("umfrage_sessionid") as string;

    var nameValueCollection: any = [];
    var keysCount = Object.keys(dataItem).length;

    for (var i = 0; i < keysCount; i++) {
      var id = Object.keys(dataItem)[i];
      var value = dataItem[id];

      nameValueCollection.push({ "Id": id, "Value": value });

    }

    umfrage.listSysteme.forEach((v: ListSysteme, i: any) => {
      if (v.isChecked) {
        nameValueCollection.push({ "Code": "System", "Value": v.id });
      }
    })

    fetch(`${config.Umfrage_URL}umfrage`, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'SESSION_ID': session_id },
      body: JSON.stringify(nameValueCollection)
    }).then(function(){
      setButtonIsLoading(false);
      document.getElementById("formDiv")?.scrollTo({ top: 0, behavior: 'smooth' });
    });

    
  }

  const handleChange = (e: StepperChangeEvent) => {
    
    var abschnitt = abschnitte[e.value];
    var isFinalePage = false;

    if ((abschnitte.length - 1) == e.value) {
      isFinalePage = true;
    }

    setIsFinalPage(isFinalePage);
    setCurrentAbschnitt(abschnitt);
    setValue(e.value);

  };

  const handleSystemChanged = (e: CheckboxChangeEvent) => {
    setChecked(true);
  };

  const [dataState, setDataState] = React.useState<ListSysteme[]>(
    umfrage.listSysteme.map((dataItem: ListSysteme) =>
      Object.assign({ selected: false }, dataItem)
    )
  );

  const onChangeArt = (a: any, id: any) => {

    var systems = umfrage.listSysteme;

    // var currentSystem = systems.find(p => p.id === id)!;

    for (var idx in umfrage.listSysteme) {
      var system = umfrage.listSysteme[idx];

      if (system.id == id) {
        system.isChecked = !system.isChecked;
      }
    }

    loadAbschnitte();
  }

  const handleCheckboxListChanged = (val1: any, newValue: string, isChecked: boolean) => {

    var element = document.getElementsByName(val1).length == 0 ? null : document.getElementsByName(val1)[0] as HTMLInputElement;
    if (element == null) {
      element = document.createElement("input");
      element.type = "text";
      element.setAttribute("customAttrType", "checkbox");
      element.name = val1;
      element.id = val1;
      document.body.append(element);
    }

    var currentValues = element.value == null || element.value == "" ? [] : element.value.split(',');

    var exists = false;

    currentValues.forEach((item: string) => {
      if (item == newValue) {
        exists = true;
      }
    });

    var currentArray: any[] = currentValues;

    if (isChecked && !exists) {
      currentArray.push(newValue);
    }

    if (!isChecked && exists) {
      for (var i in currentValues) {

        var item = currentValues[i];

        if (item == newValue)
          currentArray.splice(parseInt(i), 1);
      }
    }

    element.value = currentArray.join(",");
    loadAbschnitte();
  };

  const handleBooleanChanged = (frage: ListFragen, event: any) => {


    for (let index = 0; index < currentAbschnitt.listFragen.length; index++) {
      const element = currentAbschnitt.listFragen[index];

      if (element.dependingOn == frage.id) {
        element.isVisible = !element.isVisible;
      }
    }

    if (umfrage.listAbschnitte.length > 1)

      umfrage.listAbschnitte.forEach((abschnitt: ListAbschnitte) => {

        if (abschnitt.dependingOnValue != "") {
          var frage = abschnitt.listFragen.find(_ => _.id == abschnitt.dependingOn);

          if (frage != null) {
          }
        }

      });

    loadAbschnitte();
  };

  const MyItemRender = (props: ListViewItemProps) => {
    let item = props.dataItem;

    return (
      <Card orientation="horizontal" style={{ borderWidth: "0px 0px 1px", borderRadius: "0px" }}>
        <CardBody>
          <div className="k-hbox k-justify-content-between k-flex-wrap">
            <div onClick={this} style={{ width: "100%", padding: "0 0", display: "inline", fontFamily: 'Varela Round' }}>
              
              <div style={{marginRight:"10px",float:"left"}}>
                <Switch
                  onChange={(e) => onChangeArt(e, item.id)}
                  size={"small"}
                  checked={item.isChecked}
                />
              </div>
              {item.label}
            </div></div>
        </CardBody>
      </Card>
    );
  };

  return (

    <div className="d-flex flex-column min-vh-80 justify-content-center align-items-center">
      {loading ? (
        <Loader className="centered" size="large" type="converging-spinner" />
      ) : (
        <div className="card">
          <div className="form">
            <div className="left-side">
              <div className="left-heading">
                <h3></h3>
              </div>

              <Stepper
                style={{ margin: "15px 25px", fontFamily: "Varela Round" }}
                value={value}
                className="navStepper"
                onChange={handleChange}
                items={abschnitte}
                orientation={"vertical"}
              />

              <div style={{
                position: "absolute", bottom: "2px", margin: "30px", fontFamily: "Poppins"
              }}>
                <h3 className="gfaTitle" style={{ color: "white" }}>Contact</h3>
                <div style={{ height: "40px", color: "white", fontWeight: "400" }} className="dbox w-100 d-flex align-items-center">
                  <div className="icon d-flex align-items-center justify-content-center">
                    <span style={{ color: "white" }} className="fa fa-phone"></span>
                  </div>
                  <div style={{ marginTop: "10px", color: "white", fontWeight: "400" }} className="text pl-3">
                    <p><span>Phone:</span>&nbsp;&nbsp; +49 40 52474310</p>
                  </div>
                </div>
                <div style={{ height: "40px" }} className="dbox w-100 d-flex align-items-center">
                  <div className="icon d-flex align-items-center justify-content-center">
                    <span style={{ color: "white" }} className="fa fa-paper-plane"></span>
                  </div>
                  <div style={{ marginTop: "10px" }} className="text pl-3">
                    <p><span>Email:</span>&nbsp;&nbsp; info@gfa-cert.com</p>
                  </div>
                </div>
              </div>

            </div>
            <div id="formDiv" className="right-side">
              <div className="main active">

                <div className="stepperContent">
                  <Form
                    ignoreModified={true}
                    ref={formRef}
                    onSubmit={(props) => handleSubmit(props, formRef)}
                    render={(formRenderProps: FormRenderProps) => (
                      <FormElement >

                        {value == 0 && (
                          <React.Fragment>
                            <div
                              style={{
                                backgroundColor: "white",
                                verticalAlign: "top",
                                margin: "15px",
                              }}
                              className="min-vh-80 border-15"
                            >
                              <h1 className="relative z-10 gfaTitle">{props.titleSystem}</h1>

                              <h3 className="gfaSubTitle">
                                {props.subTitleSystem}
                              </h3>

                              <ListView
                                data={systeme}
                                item={MyItemRender}
                              />
                            </div>
                          </React.Fragment>
                        )}

                        {value == 100 && (
                          <React.Fragment>
                            <div
                              style={{
                                backgroundColor: "white",
                                verticalAlign: "top",
                                margin: "10%",
                              }}
                              className="min-vh-80 border-15"
                            >

                              <div className="d-flex justify-content-center">
                                <div>
                                  <i style={{ fontSize: "32px", color: "#008294" }} className="fa-regular fa-circle-check"></i>
                                </div>
                              </div>

                              <br /> <br />
                              <div className="d-flex justify-content-center">
                                <h1 className="relative z-10 gfaTitle">{textFinish}</h1>
                              </div>

                            </div>
                          </React.Fragment>
                        )}

                        <div style={{ marginBottom: "15px" }}>
                          <div className="gfaTitle">{currentAbschnitt.titel}</div>
                          <div className="gfaSubTitle">{currentAbschnitt.subTitel}</div>
                        </div>
                        {currentAbschnitt.listFragen.map(
                          (frage: ListFragen, i) => {

                            

                            if (frage.attributeTypeCode == "Boolean") {

                              return (
                                <Field
                                autoFocus 
                                  isDebug={isDebug}
                                  targetColumn={frage.targetColumn}
                                  key={frage.id}
                                  id={frage.id}
                                  name={frage.id}
                                  label={frage.bezeichnung}
                                  visible={frage.isVisible}
                                  value={formRenderProps.valueGetter("frage.id")}
                                  component={FormSwitch}
                                  onChange={(event: any) =>
                                    handleBooleanChanged(frage, event)
                                  }

                                />
                              );
                            } else if (frage.attributeTypeCode == "Lookup") {
                              return (
                                <>
                                  <Field
                                    isDebug={isDebug}
                                    targetColumn={frage.targetColumn}
                                    key={frage.id}
                                    id={frage.id}
                                    name={frage.id}
                                    label={frage.bezeichnung}
                                    visible={frage.isVisible}
                                    textField="title"
                                    dataItemsource={frage.itemsSource}
                                    component={FormComboBox}
                                    onChange={(event: any) =>
                                      handleBooleanChanged(frage, event)
                                    } />
                                </>
                              )
                            }

                            else if (frage.attributeTypeCode == "DateTime") {

                              return (
                                <>
                                  <Field
                                    id={frage.id}
                                    key={frage.id}
                                    visible={frage.isVisible}
                                    name={frage.id}
                                    isDebug={isDebug}
                                    targetColumn={frage.targetColumn}
                                    data={frage.itemsSource}
                                    label={frage.bezeichnung}
                                    component={FormDatePicker}
                                    onChangeIt={(targetId: any, value: any, check: boolean) => {
                                      handleCheckboxListChanged(targetId, value, check)
                                    }}
                                  />

                                </>)
                            }
                            else if (frage.attributeTypeCode == "MultiSelectPicklist") {
                              console.error("frage.itemsSource", frage.itemsSource);

                              return (
                                <>
                                  <Field
                                    id={frage.id}
                                    key={frage.id}
                                    visible={frage.isVisible}
                                    name={frage.id}
                                    isDebug={isDebug}
                                    targetColumn={frage.targetColumn}
                                    data={frage.itemsSource}
                                    label={frage.bezeichnung}
                                    component={FormCheckboxList}
                                    onChangeIt={(targetId: any, value: any, check: boolean) => {
                                      handleCheckboxListChanged(targetId, value, check)
                                    }}
                                  />

                                </>
                              )
                            }
                            else if (frage.attributeTypeCode == "Picklist") {
                              return (
                                <>
                                  <Field
                                    isDebug={isDebug}
                                    targetColumn={frage.targetColumn}
                                    key={frage.id}
                                    id={frage.id}
                                    name={frage.id}
                                    hinweis={frage.hinweis}
                                    label={frage.bezeichnung}
                                    visible={frage.isVisible}
                                    textField="title"
                                    data={frage.itemsSource}
                                    component={FormComboBox}
                                    onChange={(event: any) =>
                                      handleBooleanChanged(frage, event)
                                    } />
                                </>)
                            }
                            else if (frage.attributeTypeCode == "Memo") {
                              return (
                                <Field
                                  isDebug={isDebug}
                                  targetColumn={frage.targetColumn}
                                  key={frage.id}
                                  id={frage.id}
                                  name={frage.id}
                                  label={frage.bezeichnung}
                                  visible={frage.isVisible}
                                  hinweis={frage.hinweis}
                                  textField="title"
                                  data={frage.itemsSource}
                                  component={FormTextArea}
                                  onChange={(event: any) =>
                                    handleBooleanChanged(frage, event)
                                  } />)
                            }
                            else if (frage.attributeTypeCode == "TextArea") {

                              return (
                                <Field
                                  isDebug={isDebug}
                                  targetColumn={frage.targetColumn}
                                  key={frage.id}
                                  id={frage.id}
                                  name={frage.id}
                                  hinweis={frage.hinweis}
                                  label={frage.bezeichnung}
                                  visible={frage.isVisible}
                                  textField="title"
                                  data={frage.itemsSource}
                                  component={FormTextArea}
                                  onChange={(event: any) =>
                                    handleBooleanChanged(frage, event)
                                  } />)
                            }
                            else if (frage.attributeTypeCode == "Integer") {
                              return (
                                <Field
                                  isDebug={isDebug}
                                  targetColumn={frage.targetColumn}
                                  key={frage.id}
                                  id={frage.id}
                                  name={frage.id}
                                  label={frage.bezeichnung}
                                  visible={frage.isVisible}
                                  textField="title"
                                  data={frage.itemsSource}
                                  component={FormNumericTextBox}
                                  onChange={(event: any) =>
                                    handleBooleanChanged(frage, event)
                                  } />)
                            }
                            else if (frage.attributeTypeCode == "Text") {

                              switch(frage.id){
                                case "081bc0e2-1093-ed11-aad1-000d3adf7d8e":
                                case "57d4e380-a2c7-ed11-b597-000d3adf7d8e":
                                case "76d4e380-a2c7-ed11-b597-000d3adf7d8e":
                                case "d9f9338d-a2c7-ed11-b597-000d3adf7d8e":
                                  
                                  return (
                                    <>
                                      <Field
                                        isDebug={isDebug}
                                        targetColumn={frage.targetColumn}
                                        key={frage.id}
                                        id={frage.id}
                                        name={frage.id}
                                        label={frage.bezeichnung}
                                        visible={frage.isVisible}
                                        validator={(v) => requiredValidator(props.match.params.language,v)}
                                        textField="title"
                                        hinweis={frage.hinweis}
                                        data={frage.itemsSource}
                                        component={FormInput}
                                        onChange={(event: any) =>
                                          handleBooleanChanged(frage, event)
                                        } />
                                    </>
                                  )

                                default:
                                  return (
                                    <>
                                      <Field
                                        isDebug={isDebug}
                                        targetColumn={frage.targetColumn}
                                        key={frage.id}
                                        id={frage.id}
                                        name={frage.id}
                                        label={frage.bezeichnung}
                                        visible={frage.isVisible}
                                        textField="title"
                                        hinweis={frage.hinweis}
                                        data={frage.itemsSource}
                                        component={FormInput}
                                        onChange={(event: any) =>
                                          handleBooleanChanged(frage, event)
                                        } />
                                    </>
                                  )
                              }

                           
                            }
                            else {


                              return (
                                <>
                                  <Label className="questionLabel"
                                  >
                                    {frage.bezeichnung}
                                  </Label>

                                  {isDebug &&
                                    <MultiColumnComboBox
                                      data={data}
                                      filterable={true}
                                      textField={"schemaName"}
                                      dataItemKey="schemaName"
                                      onChange={(ev: ComboBoxChangeEvent) => OnChangeComboboxFrage(frage, ev)}
                                      defaultValue={frage.targetColumn.toLowerCase()}
                                      onFilterChange={handleFilterChange}
                                      style={{ width: "600px" }}
                                      placeholder="Please select ..." columns={columns} />
                                  }
                                </>
                              );
                            }
                          }
                        )}


                        <div style={{ margin: "25px 0px 0px 0px" }}>
                          {value < 100 && !isFinalPage &&
                            <>
                              <div className="k-form-buttons">
                                <Button type="button"
                                  onClick={() => goBack()}
                                  themeColor={"secondary"}
                                >{btnZuerueck}</Button>
                                <Button disabled={ButtonIsLoading} themeColor={"primary"} type={"submit"}>
                                  {btnWeiter}
                                </Button>
                              </div>
                            </>
                          }

                          {isFinalPage && value != 100 &&
                            <>
                              <div className="k-form-buttons">
                                <Button themeColor={"primary"}  disabled={ButtonIsLoading} type={"submit"}>
                                  {btnFormularAbsenden}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                        {/* <div className="k-form-buttons">
                          <Button
                            themeColor={"primary"}
                            type={"submit"}
                           
                          >
                            Send Reservation Request
                          </Button>
                          <Button onClick={formRenderProps.onFormReset}>Clear</Button>
                        </div> */}
                        {/* </fieldset> */}
                      </FormElement>
                    )
                    }
                  />

                </div>
              </div>
            </div>
          </div>
        </div>)}
    </div>
  )
}
export default Form_PageComponent;
